(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/init.js');

'use strict';

const logger = svs.core.log.getLogger('component:youtube-video_init');
const {
  trackEvent
} = svs.components.analytics;
const YOUTUBE_URL = 'https://www.youtube-nocookie.com';
const eventNotifier = new EventTarget();
const lastEventData = new Map();

function dispatchVideoEvent(videoId, type, detail) {
  const eventName = "".concat(videoId, "_").concat(type);
  lastEventData.set(eventName, detail);
  eventNotifier.dispatchEvent(new CustomEvent(eventName, {
    detail
  }));
}
const videoStates = new Map();

svs.components.youtube_video.init = function (options) {
  if (!options.videoId) {
    logger.warn('Missing videoId');
    return;
  }
  if (options && options.selector && options.src) {
    const videoHtml = svs.components.youtube_video.templates.youtube_video(options);
    $(options.selector).append(videoHtml);
  } else {
    logger.warn('Error in options object', options);
  }
};

function sendTrackEvent(action, category, videoId, videoTitle, optValue) {
  logger.info('Sending tracking event:', action, category, videoId, videoTitle, optValue);
  trackEvent({
    action,
    category,
    opt_label: "".concat(videoId, " - ").concat(videoTitle),
    opt_value: optValue
  });
}

function handleVideoStart(videoId, videoTitle) {
  for (const [otherVideoId, videoState] of videoStates) {
    if (otherVideoId !== videoId) {
      clearTimeout(videoState.timer);
      videoStates.delete(otherVideoId);
    }
  }
  if (!videoStates.has(videoId)) {
    sendTrackEvent('Video start-youtube', 'Youtube video', videoId, videoTitle, 1);
    const timer = setTimeout(() => {
      sendTrackEvent('Video progress-youtube', 30, videoId, videoTitle, 1);
      videoStates.delete(videoId);
    }, 30000);
    videoStates.set(videoId, {
      timer,
      startTime: Date.now(),
      accumulatedTime: 0
    });
  } else {
    const videoState = videoStates.get(videoId);
    videoState.startTime = Date.now();
    if (!videoState.timer) {
      const remainingTime = 30000 - videoState.accumulatedTime * 1000;
      videoState.timer = setTimeout(() => {
        sendTrackEvent('Video progress-youtube', 30, videoId, videoTitle, 1);
        videoStates.delete(videoId);
      }, remainingTime);
    }
  }
}

function handleVideoPauseOrEnd(videoId, videoTitle) {
  const videoState = videoStates.get(videoId);
  if (videoState) {
    const playTime = (Date.now() - videoState.startTime) / 1000; 
    videoState.accumulatedTime += playTime;
    if (videoState.accumulatedTime >= 30) {
      sendTrackEvent('Video progress-youtube', 30, videoId, videoTitle, 1);
      videoStates.delete(videoId);
    } else {
      clearTimeout(videoState.timer);
      videoState.timer = null;
    }
  }
}

function sendMessage(videoId, command, optValue) {
  const iframe = document.querySelector(".js-youtube-video-".concat(videoId));
  if (iframe) {
    const message = {
      event: 'command',
      func: command,
      args: optValue ? [optValue] : []
    };
    iframe.contentWindow.postMessage(JSON.stringify(message), YOUTUBE_URL);
  }
}

svs.components.youtube_video.videoPlayer = {
  play: videoId => sendMessage(videoId, 'playVideo'),
  pause: videoId => sendMessage(videoId, 'pauseVideo'),
  stop: videoId => sendMessage(videoId, 'stopVideo'),
  seek: (videoId, position) => sendMessage(videoId, 'seekTo', position),
  volume: (videoId, volume) => sendMessage(videoId, 'setVolume', volume * 100),
  onPlay: (videoId, cb) => {
    const eventName = "".concat(videoId, "_playing");
    eventNotifier.addEventListener(eventName, e => cb(e.detail));
    if (lastEventData.has(eventName)) {
      cb(lastEventData.get(eventName));
    }
  },
  onPause: (videoId, cb) => {
    const eventName = "".concat(videoId, "_paused");
    eventNotifier.addEventListener(eventName, e => cb(e.detail));
    if (lastEventData.has(eventName)) {
      cb(lastEventData.get(eventName));
    }
  },
  onProgress: (videoId, cb) => {
    const eventName = "".concat(videoId, "_progress");
    eventNotifier.addEventListener(eventName, e => cb(e.detail));
  },
  onDuration: (videoId, cb) => {
    const eventName = "".concat(videoId, "_duration");
    eventNotifier.addEventListener(eventName, e => cb(e.detail));
    if (lastEventData.has(eventName)) {
      cb(lastEventData.get(eventName));
    }
  }
};

function receiveMessage(event) {
  if (event.origin !== YOUTUBE_URL) {
    return;
  }
  let data;
  try {
    data = JSON.parse(event.data);
  } catch (e) {
    logger.warn('Failed to parse message data:', e);
    return;
  }
  if (!data || !data.info || !data.info.videoData || !data.info.videoData.video_id) {
    return; 
  }
  const videoId = data.info.videoData.video_id;
  const videoTitle = data.info.videoData.title || '';
  if (!videoId) {
    return;
  }
  if (typeof data.info.playerState === 'number') {
    switch (data.info.playerState) {
      case 1:
        handleVideoStart(videoId, videoTitle);
        dispatchVideoEvent(videoId, 'playing', {
          videoId,
          videoTitle
        });
        break;
      case 2: 
      case 0:
        handleVideoPauseOrEnd(videoId, videoTitle);
        dispatchVideoEvent(videoId, 'paused', {
          videoId,
          videoTitle
        });
        break;
      default:
        logger.debug('Unhandled player state:', data.info.playerState);
    }
  }
  if (typeof data.info.currentTime === 'number') {
    dispatchVideoEvent(videoId, 'progress', {
      videoId,
      videoTitle,
      currentTime: data.info.currentTime
    });
  }
  if (typeof data.info.duration === 'number') {
    dispatchVideoEvent(videoId, 'duration', {
      videoId,
      videoTitle,
      duration: data.info.duration
    });
  }
}

window.addEventListener('message', receiveMessage, false);

document.addEventListener('DOMContentLoaded', () => {
  const observeAndInitializeIframes = () => {
    const initIframe = iframe => {
      if (!iframe) {
        return;
      }
      const postListening = () => {
        try {
          var _iframe$contentWindow;
          (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 || _iframe$contentWindow.postMessage('{"event":"listening","channel":"widget"}', '*');
        } catch (err) {
          logger.info('[YouTube] Failed to postMessage to iframe:', err);
        }
      };
      iframe.addEventListener('load', () => {
        postListening();
      });
      if (iframe.contentWindow && iframe.complete) {
        postListening();
      } else {
        let retries = 5;
        const interval = setInterval(() => {
          if (iframe.contentWindow) {
            postListening();
            clearInterval(interval);
          } else if (--retries <= 0) {
            clearInterval(interval);
          }
        }, 100);
      }
    };

    document.querySelectorAll('.js-youtube-video-iframe').forEach(initIframe);

    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            var _node$matches, _node$querySelectorAl;
            if ((_node$matches = node.matches) !== null && _node$matches !== void 0 && _node$matches.call(node, '.js-youtube-video-iframe')) {
              initIframe(node);
            }
            (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 || (_node$querySelectorAl = _node$querySelectorAl.call(node, '.js-youtube-video-iframe')) === null || _node$querySelectorAl === void 0 || _node$querySelectorAl.forEach(initIframe);
          }
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };
  observeAndInitializeIframes();
});

 })(window);